import Vue from "vue";
import VueIn8n from "vue-i18n";
import cn from "./langs/cn";
import en from "./langs/en";
import kr from "./langs/kr";
import tw from "./langs/tw";
import de from "./langs/de";
import es from "./langs/es";
import gb from "./langs/gb";
import it from "./langs/it";
const messages = {
  cn,
  en,
  kr,
  tw,
  de,
  es,
  gb,
  it
};

Vue.use(VueIn8n);
const dateTimeFormats = {
  cn: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true
    },
    cs: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  en: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric"
    },
    cs: {
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      year: "numeric",
      month: "short",
      day: "numeric"
    }
  },
  kr: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true
    },
    cs: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  tw: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  de: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  gb: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  it: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  },
  tw: {
    tiny: {
      year: "numeric",
      month: "short"
    },
    small: {
      month: "short",
      day: "numeric"
    },
    short: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      second: "numeric"
    }
  }
};
const i18n = new VueIn8n({
  locale: localStorage.getItem("lang") || "cn", //初始未选择语言默认中文 cn
  messages,
  dateTimeFormats
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js